import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.web.scss';
import App from './web/app.web';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
